import { CustomerDbModel } from 'common/modules/customers';
import { getTranslation, Languages } from 'common/modules/translations';
import { Category, ProductApi } from 'common/types';
import { Hash } from 'common/utils/arrays';
import { TFunction } from 'react-i18next';
import { getChannelName } from 'views/Rental/SideBar/utils';

export interface CustomersTableRow {
	id: string;
	firstName: string;
	lastName: string;
	phone: string;
	email: string;
	marketingConsent: string;
	products: string;
	total: number;

	purchaseDate: string;
	categories: string;
	channels: string;
	totalOrders: number;
}

export const customerToCustomersTableRow = (deps: {
	defaultLanguage: Languages;
	categoriesById: Hash<Category>;
	productsById: Hash<ProductApi>;
	t: TFunction;
}) => (customer: CustomerDbModel): CustomersTableRow => {
	const { defaultLanguage, categoriesById, productsById, t } = deps;

	const categories =
		customer.categoryIds
			?.map((id) => {
				const category = categoriesById[id];
				return !!category ? getTranslation(category.name, defaultLanguage) : '';
			})
			.filter((name) => !!name)
			.join(', ') ?? '';

	const products = customer.productIds
		.map((id) => getTranslation(productsById[id]?.name, defaultLanguage))
		.filter((product) => !!product)
		.join(', ');

	const channels = customer.channels.map((channel) => getChannelName(channel, t)).join(', ');

	return {
		id: customer.id,
		firstName: customer.firstName,
		lastName: customer.lastName,
		email: customer.email ?? '',
		phone: customer.phone,
		marketingConsent: !!customer.marketing
			? t('common:actions.yes', 'Yes')
			: t('common:actions.no', 'No'),
		categories,
		total: customer.ordersTotal / 100,
		products,
		purchaseDate: customer.lastPurchaseDate ?? '',
		channels,
		totalOrders: customer.ordersCount,
	};
};
